import React, { useEffect, useMemo, useState } from "react";
import { Badge, Card, CardBody, CardHeader, Col, Container, Row, Table } from "reactstrap";

import AdminPageHeader from "components/admin/AdminPageHeader";
import EmptyState from "components/EmptyState";
import { dealsRepo } from "data/repositories/dealsRepo";
import { favoritesRepo } from "data/repositories/favoritesRepo";
import { provincesRepo } from "data/repositories/provincesRepo";

export default function AdminFavoritesOverview() {
  const [summary, setSummary] = useState({ provinceIds: [], dealIds: [], users: [] });

  useEffect(() => {
    setSummary(favoritesRepo.get());
  }, []);

  const provinceMap = useMemo(() => {
    const map = new Map();
    provincesRepo.list().forEach((item) => map.set(item.id, item));
    return map;
  }, []);

  const dealMap = useMemo(() => {
    const map = new Map();
    dealsRepo.list().forEach((item) => map.set(item.id, item));
    return map;
  }, []);

  return (
    <>
      <AdminPageHeader
        title="Yönetim — Favori İstatistikleri"
        description="Mobil kullanıcı favorileri Firebase userFavorites koleksiyonundan okunur."
      />
      <Container className="mt--6" fluid>
        {!summary.provinceIds.length && !summary.dealIds.length ? (
          <EmptyState title="Favori verisi yok" description="Kullanıcılar uygulamada favori ekledikçe burada görünür." />
        ) : null}
        <Row>
          <Col xl="6">
            <Card className="shadow mb-4">
              <CardHeader className="border-0">
                <h3 className="mb-0">Favori şehirler (benzersiz)</h3>
              </CardHeader>
              <CardBody>
                <div className="display-4 mb-3">{summary.provinceIds.length}</div>
                {summary.provinceIds.map((id) => (
                  <Badge key={id} color="info" pill className="mr-1 mb-1">
                    {provinceMap.get(id)?.name || id}
                  </Badge>
                ))}
              </CardBody>
            </Card>
          </Col>
          <Col xl="6">
            <Card className="shadow mb-4">
              <CardHeader className="border-0">
                <h3 className="mb-0">Favori fırsatlar (benzersiz)</h3>
              </CardHeader>
              <CardBody>
                <div className="display-4 mb-3">{summary.dealIds.length}</div>
                {summary.dealIds.map((id) => (
                  <Badge key={id} color="primary" pill className="mr-1 mb-1">
                    {dealMap.get(id)?.title || id}
                  </Badge>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Card className="shadow">
          <CardHeader className="border-0">
            <h3 className="mb-0">Kullanıcı bazlı favoriler</h3>
          </CardHeader>
          <CardBody>
            <Table responsive hover>
              <thead>
                <tr>
                  <th>Kullanıcı</th>
                  <th>Şehir</th>
                  <th>Fırsat</th>
                </tr>
              </thead>
              <tbody>
                {(summary.users || []).map((user) => (
                  <tr key={user.id || user.userId}>
                    <td>{user.userId || user.id}</td>
                    <td>{(user.provinceIds || []).length}</td>
                    <td>{(user.dealIds || []).length}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </>
  );
}
